import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import {ProductService} from './product.service';
import {ProductOverviewComponent} from './product-overview.component';
import {ProductFormComponent} from './product-form.component';

@NgModule({
  declarations: [
    ProductOverviewComponent,
    ProductFormComponent
  ],
  exports: [
    ProductOverviewComponent,
    ProductFormComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    ProductService
  ]
})
export class ProductModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/product/product.module.ts